interface Props {
  color?: string;
  className?: string;
}

export default function SecuritySvg(props: Props) {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15 10.5L11.3536 14.1464C11.1583 14.3417 10.8417 14.3417 10.6464 14.1464L9 12.5M7.58333 3.5H16.4167C16.7388 3.5 17 3.76117 17 4.08333C17 5.69416 18.3058 7 19.9167 7H20.3333C20.7015 7 21 7.29848 21 7.66667V8.52527C21 14.0645 17.9969 19.1684 13.1547 21.8585L12.7764 22.0686C12.2936 22.3369 11.7064 22.3369 11.2236 22.0686L10.8453 21.8585C6.00313 19.1684 3 14.0645 3 8.52527V7.66667C3 7.29848 3.29848 7 3.66667 7H4.08333C5.69416 7 7 5.69416 7 4.08333C7 3.76117 7.26117 3.5 7.58333 3.5Z'
        stroke='white'
        stroke-width='2'
        stroke-linecap='round'
      />
    </svg>
  );
}
